export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line', slug: 'all' },
  { id: 'movie', name: '电影', icon: 'ri-film-line', slug: 'movie' },
  { id: 'tv', name: '电视剧', icon: 'ri-tv-line', slug: 'tv' },
  { id: 'anime', name: '动漫', icon: 'ri-emotion-line', slug: 'anime' },
  { id: 'variety', name: '综艺', icon: 'ri-mic-line', slug: 'variety' },
  { id: 'documentary', name: '纪录片', icon: 'ri-earth-line', slug: 'documentary' },
  { id: 'music', name: '音乐', icon: 'ri-music-line', slug: 'music' },
  { id: 'game', name: '游戏', icon: 'ri-gamepad-line', slug: 'game' },
  { id: 'sports', name: '体育', icon: 'ri-basketball-line', slug: 'sports' },
  { id: 'kids', name: '少儿', icon: 'ri-heart-line', slug: 'kids' },
];

export const videos = [
  {
    id: 1,
    title: '流浪地球3：星际远征',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20promotional%20poster%20with%20starry%20sky%20and%20giant%20planet%2C%20cinematic%20lighting%2C%20dark%20background%20with%20blue%20and%20orange%20glow%2C%20epic%20movie%20poster%20style%2C%20professional%20film%20photography%2C%20dramatic%20atmosphere&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '148分钟',
    quality: '4K',
    year: 2025,
    rating: 9.2,
    views: '1280万',
    description: '在浩瀚宇宙中，人类文明的命运悬于一线。当地球再次面临毁灭性危机，新一代宇航员肩负起拯救全人类的重任。一场史无前例的星际远征，将决定人类文明的未来。',
    tags: ['科幻', '冒险', '国产'],
    updateInfo: '更新至HD高清',
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '繁花深处',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20cityscape%20with%20vintage%201990s%20Shanghai%20streets%2C%20warm%20golden%20lighting%2C%20nostalgic%20aesthetic%2C%20cinematic%20composition%2C%20soft%20film%20grain%20texture%2C%20elegant%20mood&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '45分钟/集',
    quality: '1080P',
    year: 2025,
    rating: 8.9,
    views: '980万',
    description: '以上海为背景，讲述了改革开放初期一群年轻人的奋斗故事。在时代洪流中，他们追逐梦想、守护爱情，演绎了一段荡气回肠的都市传奇。',
    tags: ['都市', '情感', '年代'],
    updateInfo: '更新至第32集',
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '深海探秘：未知世界',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20with%20bioluminescent%20sea%20creatures%2C%20dark%20blue%20underwater%20scene%2C%20mysterious%20marine%20life%2C%20science%20documentary%20style%2C%20professional%20underwater%20photography%2C%20ethereal%20atmosphere&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '52分钟/集',
    quality: '4K',
    year: 2025,
    rating: 9.5,
    views: '650万',
    description: '跟随顶级海洋生物学家的脚步，深入地球最神秘的深海世界。从马里亚纳海沟到百慕大三角，揭开海洋深处那些不为人知的秘密与奇观。',
    tags: ['自然', '科学', '探索'],
    updateInfo: '全6集已完结',
    isHot: false,
    isNew: true,
  },
  {
    id: 4,
    title: '仙剑奇缘之苍兰诀',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20donghua%20animation%20with%20floating%20islands%20and%20magical%20creatures%2C%20ethereal%20mountain%20palace%2C%20soft%20dreamy%20lighting%2C%20anime%20art%20style%2C%20beautiful%20colorful%20sky%2C%20romantic%20fantasy%20atmosphere&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '24分钟/集',
    quality: '1080P',
    year: 2025,
    rating: 9.0,
    views: '1560万',
    description: '改编自经典仙侠小说，讲述了一个平凡少年意外踏入修仙世界的奇幻冒险。在苍兰秘境中，他将揭开尘封千年的仙魔大战真相，与命中注定的伙伴一起守护天地平衡。',
    tags: ['奇幻', '仙侠', '冒险'],
    updateInfo: '更新至第48集',
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '欢乐喜剧人2025',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20with%20colorful%20lights%20and%20comedians%2C%20bright%20energetic%20studio%20set%2C%20entertainment%20show%20atmosphere%2C%20professional%20stage%20lighting%2C%20vibrant%20warm%20colors&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '90分钟/期',
    quality: '1080P',
    year: 2025,
    rating: 8.5,
    views: '2100万',
    description: '国内最受欢迎的喜剧竞演节目重磅回归！全国顶尖喜剧人齐聚一堂，带来一场场令人捧腹的精彩表演。笑点密集，欢乐不停，每一期都是快乐的盛宴。',
    tags: ['喜剧', '搞笑', '竞演'],
    updateInfo: '更新至第10期',
    isHot: true,
    isNew: true,
  },
  {
    id: 6,
    title: '东风破·国风音乐会',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20music%20concert%20with%20guqin%20and%20stage%20lights%2C%20ink%20wash%20painting%20style%20visual%20effects%2C%20elegant%20classical%20atmosphere%2C%20cultural%20performance%2C%20warm%20golden%20lighting%2C%20artistic%20composition&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '120分钟',
    quality: '4K',
    year: 2025,
    rating: 9.3,
    views: '420万',
    description: '汇聚国内顶尖国风音乐人，将古典韵律与现代音乐完美融合。从古琴到电音，从诗词到说唱，一场穿越千年的声音盛宴，带你感受中华文化的无限魅力。',
    tags: ['音乐', '国风', '文化'],
    updateInfo: 'HD高清完整版',
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: '英雄联盟全球总决赛回顾',
    category: 'game',
    thumbnail: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20LED%20screens%20and%20crowded%20stadium%2C%20competitive%20gaming%20stage%2C%20dynamic%20blue%20and%20red%20lighting%2C%20grand%20championship%20atmosphere%2C%20professional%20esports%20photography%2C%20epic%20scale&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '180分钟',
    quality: '4K',
    year: 2025,
    rating: 9.1,
    views: '3200万',
    description: '全球最顶级的电竞赛事精彩回顾！重温那些令人热血沸腾的巅峰对决，从小组赛到总决赛，每一场都是经典。包含专业解说点评和幕后花絮。',
    tags: ['电竞', '比赛', '精彩集锦'],
    updateInfo: '4K超清完整版',
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    title: 'NBA巅峰对决：湖人大战勇士',
    category: 'sports',
    thumbnail: 'https://readdy.ai/api/search-image?query=Basketball%20game%20action%20shot%20with%20player%20dunking%2C%20NBA%20arena%20atmosphere%2C%20dramatic%20sports%20lighting%2C%20professional%20sports%20photography%2C%20intense%20competition%20moment%2C%20warm%20arena%20lights&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '150分钟',
    quality: '1080P',
    year: 2025,
    rating: 8.8,
    views: '890万',
    description: '本赛季最受瞩目的NBA焦点战！两支超级球队的巅峰碰撞，巨星之间的华丽对决。全程高清录制，包含赛中精彩回放与战术分析。',
    tags: ['篮球', 'NBA', '体育'],
    updateInfo: '全场高清回放',
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '小猪佩奇大冒险',
    category: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20animated%20pig%20family%20in%20colorful%20countryside%2C%20children%20cartoon%20style%2C%20bright%20cheerful%20colors%2C%20green%20hills%20and%20blue%20sky%2C%20playful%20and%20happy%20atmosphere%2C%20simple%20and%20charming%20illustration&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '5分钟/集',
    quality: '1080P',
    year: 2025,
    rating: 9.4,
    views: '5600万',
    description: '风靡全球的学龄前动画片全新一季！可爱的小猪佩奇和她的家人朋友们，带孩子们一起探索世界、学习知识。寓教于乐，陪伴孩子快乐成长每一天。',
    tags: ['动画', '儿童', '教育'],
    updateInfo: '更新至第52集',
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '时空穿越者',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Time%20travel%20sci-fi%20film%20with%20clock%20mechanisms%20and%20portal%20effects%2C%20cinematic%20lighting%20with%20warm%20golden%20and%20cool%20blue%20contrast%2C%20mysterious%20atmosphere%2C%20epic%20movie%20poster%20style%2C%20professional%20film%20photography&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '135分钟',
    quality: '4K',
    year: 2025,
    rating: 8.7,
    views: '760万',
    description: '一位物理学家意外发现了时间穿越的秘密，却因此卷入了一场跨越百年的阴谋。他必须在过去与未来之间穿梭，拯救自己最爱的人。',
    tags: ['科幻', '悬疑', '爱情'],
    updateInfo: '更新至HD高清',
    isHot: false,
    isNew: true,
  },
  {
    id: 11,
    title: '长安十二时辰续',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%20with%20lanterns%20and%20palace%20architecture%2C%20historical%20drama%20aesthetic%2C%20warm%20candlelight%20illumination%2C%20mysterious%20night%20atmosphere%2C%20cinematic%20composition%2C%20epic%20period%20drama%20style&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '45分钟/集',
    quality: '1080P',
    year: 2025,
    rating: 9.1,
    views: '1450万',
    description: '盛唐长安，暗流涌动。当一场更大的阴谋浮出水面，昔日英雄再度集结。在十二个时辰内，他们必须破解谜题，拯救长安城的百万百姓。',
    tags: ['古装', '悬疑', '历史'],
    updateInfo: '更新至第24集',
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    title: '美食中国：寻味之旅',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cuisine%20food%20documentary%20with%20steaming%20dishes%20and%20fresh%20ingredients%2C%20warm%20kitchen%20lighting%2C%20traditional%20Chinese%20cooking%20scene%2C%20appetizing%20food%20photography%2C%20rich%20colors%20and%20textures%2C%20cultural%20culinary%20aesthetic&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '45分钟/集',
    quality: '4K',
    year: 2025,
    rating: 9.6,
    views: '1880万',
    description: '走遍中国大江南北，探寻各地最具特色的美食文化。从街头小吃到宫廷御膳，每一道菜背后都有一段动人的故事。用镜头记录下最美味的中国记忆。',
    tags: ['美食', '文化', '旅行'],
    updateInfo: '全10集已完结',
    isHot: true,
    isNew: false,
  },
];

export const recommendedVideos = [1, 4, 5, 7, 11, 12];

export const latestVideos = [3, 5, 6, 8, 10, 2];

export const hotVideos = [1, 2, 4, 7, 11, 12];